import NodeBasicPage from '../implementations/Node/BasicPage';
import NodeParagraphsPage from '../implementations/Node/ParagraphsPage';
import NodeLandingPage from '../implementations/Node/LandingPage';
import Article from '../implementations/Node/Article';
import News from '../implementations/Node/News';
import Opinion from '../implementations/Node/Opinion';
import Download from '../implementations/Node/Download';
import Staff from '../implementations/Node/Staff';
import CourseInfo from '../implementations/Node/CourseInfo';
import Member from '../implementations/Node/Member';
import NodeAnnualReport from '../implementations/Node/AnnualReport';
import FAQ from '../implementations/Node/FAQ';
import Course from '../implementations/Node/Course';
import Cao from '../implementations/Node/Cao';
import Dossier from '../implementations/Node/Dossier';
import Interview from '../implementations/Node/Interview';

const mappers = {
  basic_page: NodeBasicPage,
  landing_page: NodeLandingPage,
  paragraph_page: NodeParagraphsPage,
  article: Article,
  news: News,
  opinion: Opinion,
  interview: Interview,
  download: Download,
  staff_member: Staff,
  course: Course,
  course_information: CourseInfo,
  member: Member,
  jaaroverzicht: NodeAnnualReport,
  faq_item: FAQ,
  cao: Cao,
  dossier: Dossier,
};

export default mappers;
